import { Component } from '@angular/core';

@Component({
  selector: 'lkd-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'lkd-ng-likuidWeb';
}
